import { useField } from "formik";
import FilesUpload from "components/FilesUpload";

const FormikFilesUpload = ({ name, ...rest }) => {
  const [field, meta, helpers] = useField({ name });

  const handleChange = (files) => {
    helpers.setValue(files);
  };

  return <FilesUpload {...rest} {...field} {...meta} onChange={handleChange} />;
};

export default FormikFilesUpload;
